import { v4 as uuidv4 } from 'uuid';

/**
 * 브라우저별 고유 사용자 식별 코드 생성/관리
 * 원본: wehago-conference/src/utils/index.js → getUserIdentificationCode()
 *
 * 동일 브라우저에서 동일 탭이 아닌 중복 접속(고스트 세션)을 판별하기 위해 사용.
 * localStorage에 영속되며, 없으면 WebCrypto SHA-256로 새로 생성한다.
 */

const STORAGE_KEY = 'userIdentification';

function generateCode(): string {
  const arr = new Uint8Array(32);
  crypto.getRandomValues(arr);
  return Array.from(arr, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function getUserIdentificationCode(): string {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return stored;

    const code = generateCode();
    localStorage.setItem(STORAGE_KEY, code);
    return code;
  } catch {
    // private browsing 등 localStorage 접근 불가 시 세션 한정 코드
    return generateCode();
  }
}

/**
 * standby API(lpevent, requestJoinRoom, responseJoinRoom)에서 사용하는 사용자 식별 UUID.
 * 서버 DB 컬럼(t_standby_users.user_identify, t_lpevent_users.user_identify)이
 * DataTypes.UUID이므로 반드시 UUID v4 형식이어야 한다.
 * localStorage에 영속되며, 없으면 새로 생성한다.
 */
const USER_IDENTIFY_KEY = 'userIdentify';

export function getUserIdentify(): string {
  try {
    const stored = localStorage.getItem(USER_IDENTIFY_KEY);
    if (stored) return stored;

    const id = uuidv4();
    localStorage.setItem(USER_IDENTIFY_KEY, id);
    return id;
  } catch {
    return uuidv4();
  }
}
